import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { OdsServices } from '../../services';
import { OdsConfigHoraryPage } from '../../ods-config/ods-config-horary/ods-config-horary';
import { OdsConfigShipmentPage } from '../../ods-config/ods-config-shipment/ods-config-shipment';
import { OdsConfigMenuPage } from '../../ods-config/ods-config-menu/ods-config-menu';
import { OdsConfigPaymentsPage } from '../../ods-config/ods-config-payments/ods-config-payments';
import { OdsConfigCustomizePage } from '../../ods-config/ods-config-customize/ods-config-customize';
import { ConfigurationRestWebZipcodePage } from '../../../configuration/configuration-rest-web/configuration-rest-web-zipcode/configuration-rest-web-zipcode';
import { OdsConfigMenuCreatePage } from '../../ods-config/ods-config-menu/ods-config-menu-create/ods-config-menu-create';
import { AnalyticsPage } from '../../../analytics/analytics';
import { HttpClient, HttpParams } from '@angular/common/http';
import { QRServices } from '../../../services/qrServices';
import { ConfigurationIntegrationsPage } from '../../../configuration/configuration-integrations/configuration-integrations';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ConfigurationImagesPage } from '../../../configuration/configuration-images/configuration-images';
import { ConfigurationServices } from '../../../configuration/services';
import { ConfigurationDomainsPage } from '../../../configuration/configuration-domains/configuration-domains';
import { OdsConfigModifyElementsPage } from '../../ods-config/ods-config-modify-elements/ods-config-modify-elements';
import { ConfigurationDeliveriesPage } from '../../../configuration/configuration-deliveries/configuration-deliveries';
import moment from 'moment';
import { throwError } from 'rxjs';

/**
 * Generated class for the OdsConfigurationViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-ods-configuration-view',
    templateUrl: 'ods-configuration-view.html',
})
export class OdsConfigurationViewPage implements OnInit {
    //horary
    horary_start: any = "";
    horary_end: any = "";
    horary_monday: boolean = false;
    horary_tuesday: boolean = false;
    horary_wednesday: boolean = false;
    horary_thursday: boolean = false;
    horary_friday: boolean = false;
    horary_saturday: boolean = false;
    horary_sunday: boolean = false;
    //cupons
    cupon_name: string = '';
    cupon_discount: number = 0;
    cupon_expiration_date: any;
    //restaurant info
    web_text_large_aboutus: string = '';
    //policy
    policy: string = '';
    private isSavingSection: boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public translate: TranslateService,
        public globals: Globals,
        public alertCtrl: AlertController,
        public toastCtrl: ToastController,
        public odsServices: OdsServices,
        public http: HttpClient,
        public qrServices: QRServices,
        public configurationServices: ConfigurationServices) {
    }

    ngOnInit() {
        this.web_text_large_aboutus = this.globals.restaurant.web_text_large_aboutus;
        this.policy = this.globals.restaurant.privacy_policy;

        if (!this.globals.restaurant.primary_color) {
            this.globals.restaurant.primary_color = '#000000';
        }
        if (!this.globals.restaurant.secondary_color) {
            this.globals.restaurant.secondary_color = '#FFFFFF';
        }
        // Set default values for bag option
        if (this.globals.restaurant.web_tk_bag === undefined) {
            this.globals.restaurant.web_tk_bag = false;
            this.globals.restaurant.web_tk_bag_price = 0;
            // Save to database immediately
            this.odsServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
                web_tk_bag: false,
                web_tk_bag_price: 0
            });
        }
    }

    configHorary() {
        this.navCtrl.push(OdsConfigHoraryPage);
    }

    configShipment() {
        this.navCtrl.push(OdsConfigShipmentPage);
    }

    configMenu() {
        this.navCtrl.push(OdsConfigMenuPage);
    }

    configPayments() {
        this.navCtrl.push(OdsConfigPaymentsPage);
    }

    configCustomize() {
        this.navCtrl.push(OdsConfigCustomizePage)
    }

    /********************************************************/
    /*                        HORARIS                       */
    /********************************************************/

    deleteHorary(index) {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('reservas-eliminar-horario'),
            message: this.translate.instant('reservas-eliminar-horario-desc'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.restaurant.web_schedule.splice(index, 1);
                        this.odsServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
                            web_schedule: this.globals.restaurant.web_schedule
                        });
                    }
                }
            ]
        });
        alert.present();
    }

    addHorary() {
        //Comprovar que se hayan añadido las horas, y seleccionado minimo 1 dia
        if (this.horary_start != "" && this.horary_end != "" && (this.horary_monday || this.horary_tuesday || this.horary_wednesday || this.horary_thursday || this.horary_friday || this.horary_saturday || this.horary_sunday)) {
            document.getElementById('horary_error').classList.add('d-none');
            if (!this.globals.restaurant.web_schedule || typeof (this.globals.restaurant.web_schedule) === 'string') {
                this.globals.restaurant.web_schedule = [];
            }
            this.globals.restaurant.web_schedule.push({
                start: this.horary_start,
                end: this.horary_end,
                monday: this.horary_monday,
                tuesday: this.horary_tuesday,
                wednesday: this.horary_wednesday,
                thursday: this.horary_thursday,
                friday: this.horary_friday,
                saturday: this.horary_saturday,
                sunday: this.horary_sunday
            });
            this.odsServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
                web_schedule: this.globals.restaurant.web_schedule
            });
            this.horary_start = "";
            this.horary_end = "";
            this.horary_monday = false;
            this.horary_tuesday = false;
            this.horary_wednesday = false;
            this.horary_thursday = false;
            this.horary_friday = false;
            this.horary_saturday = false;
            this.horary_sunday = false;
            //plg
            if (!this.odsServices.takeaway_config.config_horary) {
                this.odsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/takeaway').doc('config').update({
                    config_horary: true
                });
                this.odsServices.takeaway_config.config_horary = true;
            }
        } else {
            document.getElementById('horary_error').classList.remove('d-none');
        }
    }

    updateTkHours() {
        this.odsServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
            web_tk_open_hour: this.globals.restaurant.web_tk_open_hour,
            web_tk_close_hour: this.globals.restaurant.web_tk_close_hour
        });
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    /********************************************************/
    /*                       SECCIONES                      */
    /********************************************************/

    reorderSections(indexes) {
        let sections = this.globals.objectToArray(this.odsServices.carta_takeaway.pages[0].sections);
        let section = this.odsServices.carta_takeaway.pages[0].sections[indexes.from];
        //
        sections.splice(indexes.from, 1);
        sections.splice(indexes.to, 0, section);
        //
        this.odsServices.carta_takeaway.pages[0].sections = sections;
        this.odsServices.afs.collection('cartas').doc(this.odsServices.carta_takeaway.UID).update({
            'pages': this.odsServices.carta_takeaway.pages
        });
    }

    editSection(section, index) {
        this.navCtrl.push(OdsConfigMenuCreatePage, {
            update_state: true,
            section: section,
            index: index
        });
    }

    newSection() {
        this.navCtrl.push(OdsConfigMenuCreatePage, {
            update_state: false
        });
    }

    deleteSection(section, index) {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('general-eliminar-seccion'),
            message: this.translate.instant('instant-seguro-quieres-eliminarla'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        //delete
                        delete this.odsServices.carta_takeaway.pages[0].sections[index];
                        //reordenar
                        var obj_help = {};
                        var i = 0;
                        for (let item of this.globals.objectToArray(this.odsServices.carta_takeaway.pages[0].sections)) {
                            obj_help[i] = item;
                            i++;
                        }
                        this.odsServices.carta_takeaway.pages[0].sections = obj_help;
                        this.odsServices.afs.collection('cartas').doc(this.odsServices.carta_takeaway.UID).update({
                            'pages': this.odsServices.carta_takeaway.pages
                        });
                    }
                }
            ]
        });
        alert.present();
    }

    disableSection(section, index) {
        if (!this.odsServices.carta_takeaway.pages[0].sections[index].disabled) {
            let alert = this.alertCtrl.create({
                title: this.translate.instant('desactivar-secciones'),
                message: this.translate.instant('desactivar-secciones-desc'),
                buttons: [
                    {
                        text: this.translate.instant('general-no'),
                        role: 'cancel',
                        handler: () => { }
                    },
                    {
                        text: this.translate.instant('general-si'),
                        handler: () => {
                            this.performDisableSection(section, index);
                        }
                    }
                ]
            });
            alert.present();
        } else {
            let alert = this.alertCtrl.create({
                title: this.translate.instant('activar-secciones'),
                message: this.translate.instant('activar-secciones-desc'),
                buttons: [
                    {
                        text: this.translate.instant('general-no'),
                        role: 'cancel',
                        handler: () => { }
                    },
                    {
                        text: this.translate.instant('general-si'),
                        handler: () => {
                            this.performEnableSection(section, index);
                        }
                    }
                ]
            });
            alert.present();
        }
    }

    async performDisableSection(section, index) {
        // 🔒 Si ya está guardando otra sección, NO permitir
        if (this.isSavingSection) {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-espera-guardado'),
                duration: 1500,
                position: 'bottom'
            });
            toast.present();
            return;
        }

        // 🔒 Marcar como guardando
        this.isSavingSection = true;

        let loading = this.loadingCtrl.create({
            content: this.translate.instant('general-guardando')
        });
        loading.present();

        try {
            // Marcar sección como disabled en la carta (memoria local)
            this.odsServices.carta_takeaway.pages[0].sections[index].disabled = true;

            const elements = this.globals.objectToArray(section.elements);

            // UN SOLO BATCH para todo (elementos + carta) usando firestore nativo
            const batch = this.odsServices.firestore.batch();

            // Añadir actualización de elementos al batch
            for (let element of elements) {
                try {
                    let docRef;
                    if (element.type === 'product') {
                        docRef = this.odsServices.firestore.collection('products').doc(element.uid);
                    } else if (element.type === 'dish') {
                        docRef = this.odsServices.firestore.collection('dish').doc(element.uid);
                    } else if (element.type === 'combo') {
                        docRef = this.odsServices.firestore.collection('menus').doc(element.uid);
                    }
                    if (docRef) {
                        batch.update(docRef, { tk_active: false });
                    }
                } catch (error) {
                    console.error('Error preparando elemento:', element.uid, error);
                }
            }

            // Añadir actualización de carta al MISMO batch (firestore nativo)
            const cartaRef = this.odsServices.firestore.collection('cartas')
                .doc(this.odsServices.carta_takeaway.UID);
            batch.update(cartaRef, { pages: this.odsServices.carta_takeaway.pages });

            // UN SOLO commit para todo
            await batch.commit();

            loading.dismiss();

            // Mostrar confirmación
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-guardado-correctamente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();

        } catch (error) {
            loading.dismiss();
            console.error('Error disabling section:', error);
            let toast = this.toastCtrl.create({
                message: 'Error al desactivar la sección',
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        } finally {
            // 🔓 Desbloquear SIEMPRE (éxito o error)
            this.isSavingSection = false;
        }
    }

    async performEnableSection(section, index) {
        // 🔒 Si ya está guardando otra sección, NO permitir
        if (this.isSavingSection) {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-espera-guardado'),
                duration: 1500,
                position: 'bottom'
            });
            toast.present();
            return;
        }

        // 🔒 Marcar como guardando
        this.isSavingSection = true;

        let loading = this.loadingCtrl.create({
            content: this.translate.instant('general-guardando')
        });
        loading.present();

        try {
            // Marcar sección como activa en la carta (memoria local)
            this.odsServices.carta_takeaway.pages[0].sections[index].disabled = false;

            const elements = this.globals.objectToArray(section.elements);

            // UN SOLO BATCH para todo (elementos + carta) usando firestore nativo
            const batch = this.odsServices.firestore.batch();

            // Añadir actualización de elementos al batch
            for (let element of elements) {
                try {
                    let docRef;
                    if (element.type === 'product') {
                        docRef = this.odsServices.firestore.collection('products').doc(element.uid);
                    } else if (element.type === 'dish') {
                        docRef = this.odsServices.firestore.collection('dish').doc(element.uid);
                    } else if (element.type === 'combo') {
                        docRef = this.odsServices.firestore.collection('menus').doc(element.uid);
                    }
                    if (docRef) {
                        batch.update(docRef, { tk_active: true });
                    }
                } catch (error) {
                    console.error('Error preparando elemento:', element.uid, error);
                }
            }

            // Añadir actualización de carta al MISMO batch (firestore nativo)
            const cartaRef = this.odsServices.firestore.collection('cartas')
                .doc(this.odsServices.carta_takeaway.UID);
            batch.update(cartaRef, { pages: this.odsServices.carta_takeaway.pages });

            // UN SOLO commit para todo
            await batch.commit();

            loading.dismiss();

            // Mostrar confirmación
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-guardado-correctamente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();

        } catch (error) {
            loading.dismiss();
            console.error('Error enabling section:', error);
            let toast = this.toastCtrl.create({
                message: 'Error al activar la sección',
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        } finally {
            // 🔓 Desbloquear SIEMPRE (éxito o error)
            this.isSavingSection = false;
        }
    }

    moveSectionUp(index: number) {
        if (index > 0) {
            const sections = this.globals.objectToArray(this.odsServices.carta_takeaway.pages[0].sections);
            const section = sections[index];
            sections.splice(index, 1);
            sections.splice(index - 1, 0, section);

            // Update the sections in the data structure
            this.odsServices.carta_takeaway.pages[0].sections = sections;

            // Update in Firestore
            this.odsServices.afs.collection('cartas').doc(this.odsServices.carta_takeaway.UID).update({
                'pages': this.odsServices.carta_takeaway.pages
            });
        }
    }

    moveSectionDown(index: number) {
        const sections = this.globals.objectToArray(this.odsServices.carta_takeaway.pages[0].sections);
        if (index < sections.length - 1) {
            const section = sections[index];
            sections.splice(index, 1);
            sections.splice(index + 1, 0, section);

            // Update the sections in the data structure
            this.odsServices.carta_takeaway.pages[0].sections = sections;

            // Update in Firestore
            this.odsServices.afs.collection('cartas').doc(this.odsServices.carta_takeaway.UID).update({
                'pages': this.odsServices.carta_takeaway.pages
            });
        }
    }

    /********************************************************/
    /*                       SHIPMENTS                      */
    /********************************************************/

    editZipCodes() {
        this.navCtrl.push(ConfigurationRestWebZipcodePage, {
            zip_codes: this.odsServices.zip_codes
        });
    }

    async updateShipments() {
        try {
            await this.odsServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
                web_aprox_delivery_time: this.globals.restaurant.web_aprox_delivery_time || '',
                web_free_sending: this.globals.restaurant.web_free_sending || 0,
                web_sending_price: this.globals.restaurant.web_sending_price || 0,
                web_tk_min_order: this.globals.restaurant.web_tk_min_order || 0,
                web_pickup: this.globals.restaurant.web_pickup || false,
                web_delivery: this.globals.restaurant.web_delivery || false,
                web_tk_select_date: this.globals.restaurant.web_tk_select_date || false,
                web_tk_bag: this.globals.restaurant.web_tk_bag || false,
                web_tk_bag_price: this.globals.restaurant.web_tk_bag_price || 0,
            });

            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-guardado-correctamente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();

        } catch (error) {
            console.error('Error updating shipments:', error);
            let toast = this.toastCtrl.create({
                message: 'Error al guardar la configuración de envíos',
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    async updateIntervals() {
        try {
            await this.odsServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
                interval_between_orders: this.globals.restaurant.interval_between_orders || 30,
                number_orders: this.globals.restaurant.number_orders || 10,
                web_tk_asap: this.globals.restaurant.web_tk_asap || false,
            });

            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-guardado-correctamente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();

        } catch (error) {
            console.error('Error updating intervals:', error);
            let toast = this.toastCtrl.create({
                message: 'Error al guardar la configuración de intervalos',
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    /********************************************************/
    /*                        CUPONS                        */
    /********************************************************/

    addCupon() {
        if (this.cupon_name != '') {
            if (this.globals.restaurant.web_cupons === undefined) {
                this.globals.restaurant.web_cupons = [];
            }
            this.globals.restaurant.web_cupons.push({ name: this.cupon_name, discount: this.cupon_discount, expiration_date: moment(this.cupon_expiration_date).format('DD/MM/YYYY') || null });
            this.odsServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
                web_cupons: this.globals.restaurant.web_cupons
            });
            this.cupon_name = '';
            this.cupon_discount = 0;
            this.cupon_expiration_date = null;
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-rellena-todos-los-campos'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    deleteCupon(index) {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('ods-eliminar-cupon'),
            message: this.translate.instant('ods-seguro-eliminar-cupon'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.restaurant.web_cupons.splice(index, 1);
                        this.odsServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
                            web_cupons: this.globals.restaurant.web_cupons
                        });
                    }
                }
            ]
        });
        alert.present();
    }

    /********************************************************/
    /*                        CONTACT                       */
    /********************************************************/

    async updateContact() {
        try {
            await this.odsServices.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
                address: this.globals.restaurant.address,
                phone: this.globals.restaurant.phone,
                email_takeaway: this.globals.restaurant.email_takeaway,
            });

            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-guardado-correctamente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();

        } catch (error) {
            console.error('Error updating contact:', error);
            let toast = this.toastCtrl.create({
                message: 'Error al guardar la información de contacto',
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    /********************************************************/
    /*                         STATES                       */
    /********************************************************/

    updateFilterStates() {
        var interval = setInterval(() => {
            const states = [];
            this.odsServices.states.forEach(state => {
                if (state.active) {
                    states.push(state.state);
                }
            });
            this.odsServices.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/takeaway').doc('config').update({
                states_active: states
            });
            this.odsServices.filterTables();
            clearInterval(interval);
        }, 200);
    }

    /********************************************************/
    /*                         OTROS                        */
    /********************************************************/

    openAnalyticsTakeaway() {
        this.globals.side_menu_active_analytics = true;
        this.globals.side_menu_active = 'informes';
        this.navCtrl.push(AnalyticsPage, {
            scroll_id: 'analytics_takeaway'
        });
    }

    copyUrl() {
        const el = document.createElement("textarea");
        el.value = 'https://takeaway.mycheftool.com/' + this.globals.domini_sites;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        const selected =
            document.getSelection().rangeCount > 0
                ? document.getSelection().getRangeAt(0)
                : false;
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        if (selected) {
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(selected);
        }
        //toast copiado
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-copiado'),
            duration: 1000,
            position: 'top'
        });
        toast.present();
    }

    copyCode() {
        const el = document.createElement("textarea");
        el.value = '<iframe src="https://takeaway.mycheftool.com/' + this.globals.domini_sites + '"></iframe>';
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        const selected =
            document.getSelection().rangeCount > 0
                ? document.getSelection().getRangeAt(0)
                : false;
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        if (selected) {
            document.getSelection().removeAllRanges();
            document.getSelection().addRange(selected);
        }
        //toast copiado
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-copiado'),
            duration: 1000,
            position: 'top'
        });
        toast.present();
    }

    async generateQr() {
        this.qrServices.generateTakeawayQR();
    }

    stateColCss() {
        if (this.globals.platform_width === 'mobile') {
            let cssClasses = {
                'col-6': true
            }
            return cssClasses;
        } else {
            let cssClasses = {
                'col-auto': true
            }
            return cssClasses;
        }
    }

    openDeliverectIntegration() {
        //check if limit license
        if (this.globals.checkLimitsByLicense('config', 'integrations')) {
            this.globals.side_menu_config_active = 'integrations';
            this.navCtrl.setRoot(ConfigurationIntegrationsPage);
            this.globals.open_side_menu = false;
        } else {
            //caso tiene limite
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    editImages() {
        this.globals.side_menu_config_active = 'images';
        this.navCtrl.push(ConfigurationImagesPage);
    }

    getWebTextAboutUs(editor: any) {
        if (editor.event == "text-change") {
            if (editor.html) {
                this.web_text_large_aboutus = editor.html;
            } else {
                this.web_text_large_aboutus = '';
            }
        }
    }

    saveWebTextAboutUs() {
        this.globals.restaurant.web_text_large_aboutus = this.web_text_large_aboutus;
        this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            'web_text_large_aboutus': this.web_text_large_aboutus,
        });
        let toast = this.toastCtrl.create({
            message: this.translate.instant('general-guardado-correctamente'),
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    editDomain() {
        this.navCtrl.push(ConfigurationDomainsPage);
    }

    openModifyElements() {
        this.navCtrl.push(OdsConfigModifyElementsPage);
    }

    getInitPolicy(editor: any) {
        if (editor.event == "text-change") {
            if (editor.html) {
                this.policy = editor.html;
            } else {
                this.policy = '';
            }
        }
    }

    savePolicy() {
        this.configurationServices.afs.collection('restaurants/' + this.globals.restaurant_uid + '/reservations').doc('config').update({
            privacy_policy: this.policy
        }).then(ref => {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-guardado-correctamente'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        });
        //
        this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
            privacy_policy: this.policy
        });
    }

    editDeliveries() {
        this.navCtrl.push(ConfigurationDeliveriesPage);
    }

    updateColors() {
        this.configurationServices.updateRestaurantColors(
            this.globals.restaurant.primary_color,
            this.globals.restaurant.secondary_color
        );
    }

    /********************************************************/
    /*                   TOGGLE HANDLERS FIX               */
    /********************************************************/

    private updateDeliveryTimeout: any;

    updateDeliveryToggle(field: string, event: any) {
        try {
            // Actualizar inmediatamente el modelo local
            this.globals.restaurant[field] = event.checked;

            // Clear previous timeout to debounce rapid changes
            if (this.updateDeliveryTimeout) {
                clearTimeout(this.updateDeliveryTimeout);
            }

            // Debounce la actualización a la base de datos (500ms)
            this.updateDeliveryTimeout = setTimeout(async () => {
                try {
                    const updateData = {};
                    updateData[field] = event.checked;

                    await this.odsServices.firestore.collection('restaurants')
                        .doc(this.globals.restaurant_uid)
                        .update(updateData);

                    // Opcional: Mostrar toast de confirmación
                    let toast = this.toastCtrl.create({
                        message: this.translate.instant('general-guardado-correctamente'),
                        duration: 2000,
                        position: 'bottom'
                    });
                    toast.present();

                } catch (error) {
                    console.error('Error updating toggle:', field, error);

                    // Revertir el cambio local en caso de error
                    this.globals.restaurant[field] = !event.checked;

                    let toast = this.toastCtrl.create({
                        message: 'Error al guardar la configuración',
                        duration: 3000,
                        position: 'bottom'
                    });
                    toast.present();
                }
            }, 500);

        } catch (error) {
            console.error('Error in updateDeliveryToggle:', error);
        }
    }

    async goStripeDashboard() {
        var link = await this.createAccountLoginLink();
        if (link['loginLink']) {
            if (this.globals.so_mobile) {
                window.location.assign(link['loginLink']);
            } else {
                window.open(link['loginLink'], '_blank');
            }
        }
    }

    async createAccountLoginLink() {
        try {
            const params = new HttpParams()
                .set('account_id', this.globals.restaurant.connected_acount);
            const resposne_login_link = this.http.post(this.globals.analytics_path + 'stripe/create/account_login_link', params, {}).toPromise();
            return resposne_login_link;
        } catch (error) {
            // Puedes lanzar el error nuevamente o manejarlo de otra manera
            return throwError('Error en la solicitud: ' + error.message);
        }
    }

    openLinkApp(url) {
        if (this.globals.so_mobile) {
            window.location.assign(url);
        } else {
            window.open(url, '_blank');
        }
    }


}


// WEBPACK FOOTER //
// ./src/pages/ods/ods-view/ods-configuration-view/ods-configuration-view.ts